import React, { useEffect, useRef, useState } from 'react';
import { InView } from 'react-intersection-observer';
import { apiHandler } from '../../api/apihandler';
import { AD_LIST, AD_VIEW, AD_CLICK } from '../../api/constants';
import ImageSlider from '../ImageSlider';

// Middle-feed sponsored post. `adSlot` is the 1-indexed position of this
// card among all ad slots in the feed (1st every-3rd post, 2nd, ...), used
// as the page number so consecutive slots rotate through different ads
// instead of repeating the same one.
const AdFeedCard = ({ adSlot }) => {
  const [ad, setAd] = useState(null);
  const viewedRef = useRef(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiHandler(AD_LIST, 'POST', { page: adSlot, limit: 1, position: '2' });
        if (cancelled) return;
        const listData = res?.data?.data?.userPosts;
        let ads = listData?.data || [];
        if (ads.length === 0 && listData?.meta?.last_page > 0 && adSlot > listData.meta.last_page) {
          const wrapped = await apiHandler(AD_LIST, 'POST', { page: 1, limit: 1, position: '2' });
          if (cancelled) return;
          ads = wrapped?.data?.data?.userPosts?.data || [];
        }
        if (ads.length > 0) setAd(ads[0]);
      } catch (e) { console.error(e); }
    })();
    return () => { cancelled = true; };
  }, [adSlot]);

  if (!ad || !ad?.user_post_ad) return null;

  const advertiserName = `${ad?.user?.first_name || ''} ${ad?.user?.last_name || ''}`.trim() || 'Sponsored';
  const adLink = ad?.user_post_ad?.ad_link;
  const hasImages = ad?.user_post_images?.length > 0;

  const trackView = () => {
    if (viewedRef.current) return;
    viewedRef.current = true;
    apiHandler(AD_VIEW, 'POST', { ad_id: ad.id, device_type: 0 }).catch(() => {});
  };
  const trackClick = () => {
    apiHandler(AD_CLICK, 'POST', { ad_id: ad.id, device_type: 0 }).catch(() => {});
  };

  return (
    <InView as="article" className="nmha-post-card nmha-ad-card" onChange={(inView) => inView && trackView()}>
      <div className="nmha-post-top">
        <div className="nmha-ad-avatar" aria-hidden="true">
          <span className="material-symbols-outlined">campaign</span>
        </div>
        <div className="nmha-post-who">
          <b>{advertiserName}</b>
          <span>Sponsored</span>
        </div>
      </div>

      {hasImages && (
        <a href={adLink} target="_blank" rel="noopener noreferrer" onClick={trackClick} className="nmha-ad-media">
          <ImageSlider images={ad.user_post_images} />
        </a>
      )}

      <div className="nmha-post-body">
        {ad?.user_post_ad?.title ? <p className="nmha-post-title">{ad.user_post_ad.title}</p> : null}
        {ad?.content ? <p className="nmha-post-desc">{ad.content}</p> : null}
        <a href={adLink} target="_blank" rel="noopener noreferrer" onClick={trackClick} className="nmha-ad-cta">
          {ad?.user_post_ad?.button_text || 'Learn more'}
        </a>
      </div>
    </InView>
  );
};

export default AdFeedCard;
